import React, { useState } from 'react';
import { Spin, Alert } from 'antd';
import { usePW9335Query } from './hooks/usePW9335Query';
import QueryParams from './components/QueryParams';
import ResultTable from './components/ResultTable';
import type { QueryRequest } from '../../services/pw9335Api';
import './PW9335Form.css';

/**
 * Compute default year/month per BR-C01:
 * If current month is January, default year = last year.
 * Default month = month of (today - 30 days).
 */
function getDefaultYearMonth(): { year: number; month: number } {
  const now = new Date();
  const currentMonth = now.getMonth() + 1; // 1-12
  const currentYear = now.getFullYear();
  const past = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
  const pastMonth = past.getMonth() + 1;

  if (currentMonth === 1) {
    return { year: currentYear - 1, month: pastMonth };
  }
  return { year: currentYear, month: pastMonth };
}

const PW9335Form: React.FC = () => {
  const { loading, result, queried, noData, runQuery } = usePW9335Query();

  const defaults = getDefaultYearMonth();
  const [year, setYear] = useState(defaults.year);
  const [month, setMonth] = useState(defaults.month);
  const [deptFrom, setDeptFrom] = useState('');
  const [deptTo, setDeptTo] = useState('');
  const [empFrom, setEmpFrom] = useState('');
  const [empTo, setEmpTo] = useState('');
  const [deptLevel, setDeptLevel] = useState(1);
  const [company, setCompany] = useState(1);

  const handleQuery = () => {
    const req: QueryRequest = {
      year,
      month,
      deptFrom: deptFrom.trim(),
      deptTo: deptTo.trim() || 'ZZZZ',
      empFrom: empFrom.trim(),
      empTo: empTo.trim() || 'ZZZZZZZZ',
      deptLevel,
      company,
    };
    runQuery(req);
  };

  return (
    <Spin spinning={loading}>
      <div className="pw9335-container max-w-7xl mx-auto p-4">
        <h2 className="text-xl font-bold mb-4">
          個人薪資單 (pw9335f1)
        </h2>

        <QueryParams
          year={year}
          month={month}
          deptFrom={deptFrom}
          deptTo={deptTo}
          empFrom={empFrom}
          empTo={empTo}
          deptLevel={deptLevel}
          company={company}
          loading={loading}
          onYearChange={setYear}
          onMonthChange={setMonth}
          onDeptFromChange={setDeptFrom}
          onDeptToChange={setDeptTo}
          onEmpFromChange={setEmpFrom}
          onEmpToChange={setEmpTo}
          onDeptLevelChange={setDeptLevel}
          onCompanyChange={setCompany}
          onQuery={handleQuery}
        />

        {queried && !noData && result && (
          <ResultTable result={result} />
        )}

        {queried && noData && (
          <Alert
            message="查無資料"
            description="查無符合條件的薪資資料！請確認篩選條件是否正確。"
            type="info"
            showIcon
          />
        )}
      </div>
    </Spin>
  );
};

export default PW9335Form;
